import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { authApi } from "../../api";
import PasswordInput from "../../components/PasswordInput";

export default function ClientLogin() {
  const { slug: urlSlug }  = useParams();           // from /portal/:slug
  const [slug, setSlug]     = useState(urlSlug || "");
  const [email, setEmail]   = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);
  const { login }           = useAuth();
  const navigate            = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token, user } = await authApi.clientLogin(email, password, null, slug || undefined);
      login(user, token);
      navigate("/client");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="brand-icon">CS</div>
        </div>
        <h2>Venue Portal</h2>
        <p className="auth-sub">Sign in to manage your venue's members</p>
        {error && <div className="alert error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="login-slug">Venue Slug</label>
            <input
              id="login-slug"
              type="text"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              placeholder="e.g. sandbox-club"
              required
              readOnly={!!urlSlug}
              className={urlSlug ? "input-readonly" : ""}
            />
          </div>
          <div className="form-field">
            <label htmlFor="login-email">Email</label>
            <input id="login-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="manager@example.com" required />
          </div>
          <div className="form-field">
            <label htmlFor="login-password">Password</label>
            <PasswordInput id="login-password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="auth-link">
          Admin?{" "}
          <a href="/admin/login">Admin Portal →</a>
        </p>
      </div>
    </div>
  );
}

